import { Box } from "@chakra-ui/react";
import { listParams } from "~/api/listParams";
import { BriefItinerary, fetchItineraries } from "~/api/resources/Itineraries";
import { get } from "lodash";
import Head from "next/head";
import {
  FifthPanel,
  FirstPanel,
  FooterPanel,
  FourthPanel,
  SecondPanel,
  SixthPanel,
  ThirdPanel,
} from "~/components/Home";
import { Footer } from "~/components/Layout";
import { preloadedServerSideProps } from "~/lib";
import { PageProps, NextPageWithLayout } from "~/types";
import { Content, fetchContent, fetchPlatform, Media } from "~/api/resources";
import { GetServerSideProps } from "next";
type Props = PageProps<{
  itineraries: BriefItinerary[];
  logo?: Media;
  tourismoPageData: Content | null;
}>;

const Home: NextPageWithLayout<Props> = ({ itineraries, logo, tourismoPageData }: Props) => {
  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Organization",
              name: "Highway 3",
              url: "https://hwy3bc.ca",
              logo,
            }),
          }}
        />
      </Head>
      <Box display="none">
        <h1>
          Highway 3, get tips on all the hidden gems and stories, and find
          inspiration from our themed road trips as you plan your next
          adventure!
        </h1>
      </Box>
      <FirstPanel />
      <SecondPanel descriptionHome={tourismoPageData?.description ?? ""} />
      {/* <ThirdPanel /> */}
      <FourthPanel itineraries={itineraries} />
      <FifthPanel />
      <SixthPanel />
      <Box bg="gray.900">
        <Footer />
      </Box>
    </>
  );
};

Home.layoutOptions = { showFooter: false };

export const getServerSideProps: GetServerSideProps<Props> = async (
  context,
) =>
  preloadedServerSideProps<Props>({
    context,
    callback: async () => {
      const platform = await fetchPlatform();
      const tourismoPageData = await fetchContent("pageData", "home");
      const itineraries = (await fetchItineraries(listParams, true)).records;
      return {
        props: {
          itineraries,
          tourismoPageData,
          logo: platform?.logo,
          seoData: {
            metaTitle: tourismoPageData?.title ?? "Highway 3",
            metaDescription:
              tourismoPageData?.short_description ??
              tourismoPageData?.description ??
              undefined,
            metaImage: tourismoPageData?.lead_media ?? platform?.logo ?? null,
          },
        },
      };
    },
  });

export default Home;
